module.exports = __webpack_public_path__ + "img/2025big9.6428de7a.jpg";